var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 36 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 73",
    d: "M4 6.39734C4 5.07332 5.09682 4 6.4498 4C15.4833 4 24.5167 4.00007 33.5502 4.00001C34.9032 4 36 5.07333 36 6.39736V43.6027C36 44.9267 34.9032 46 33.5502 46C24.5167 46 15.4833 46 6.44981 46C5.09682 46 4 44.9267 4 43.6027V6.39734Z",
    fill: "#8E8CEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 64",
    d: "M0 2.39734C0 1.07332 1.09682 -3.53007e-07 2.4498 0C11.4833 2.35691e-06 20.5167 6.87111e-05 29.5502 1.12517e-05C30.9032 2.64562e-06 32 1.07333 32 2.39736V39.6027C32 40.9267 30.9032 42 29.5502 42C20.5167 42 11.4833 42 2.44981 42C1.09682 42 0 40.9267 0 39.6027V2.39734Z",
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 65",
    d: "M4 5C4 4.44772 4.44772 4 5 4H23C23.5523 4 24 4.44772 24 5C24 5.55228 23.5523 6 23 6H5C4.44772 6 4 5.55228 4 5Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 76",
    d: "M8 37C8 36.4477 8.44772 36 9 36H27C27.5523 36 28 36.4477 28 37C28 37.5523 27.5523 38 27 38H9C8.44772 38 8 37.5523 8 37Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 74",
    d: "M4 9C4 8.44772 4.44772 8 5 8H15C15.5523 8 16 8.44772 16 9C16 9.55228 15.5523 10 15 10H5C4.44772 10 4 9.55228 4 9Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.2839 16.6502L13.8739 24.0602L10.6853 20.8717C10.1015 20.2878 9.11347 20.2878 8.48474 20.8717C7.90092 21.4555 7.90092 22.4435 8.48474 23.0722L12.7511 27.3386C13.0655 27.653 13.4248 27.7877 13.829 27.7877C14.2331 27.7877 14.6373 27.653 14.9068 27.3386L23.4396 18.8058C24.0234 18.222 24.0234 17.234 23.4396 16.6053C22.8558 16.0214 21.8677 16.0214 21.2839 16.6502Z",
    fill: "#8E8CEE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDoc);
export default __webpack_public_path__ + "static/media/checkDoc.2cddddf57cdd59541bd7b1fb17cf48a6.svg";
export { ForwardRef as ReactComponent };